import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class UserApi {

    static async getUsers() {
        return instance.get('/users',
            params = {
                active: true,
                confirmed: true,
                roles: ''
            });
    }

    static async getUserDetails(userId) {
        return instance.get('/user/'.concat(userId));

    }

    static async getCustomerDetails(customerId){
        return instance.get('/customer/'.concat(customerId));
    }
    static async createCustomer(customer){
        return instance.post('/customer',customer)
    }

    static async getCustomerList(insta=false){
        return instance.get('customers_details/list_only', {
            params: {'insta':insta}
        })
    }

    static async createUser(email, password, TIN, phone, username) {
        return instance.post('/user', {
            email,
            phone,
            password,
            TIN,
            username
        });
    }
    static async updateCustomer(id, dni, instagram, last_name) {
        return instance.put('/customer/'+ id.toString(), {id,  dni, instagram, last_name})
    }

    static async activateUser(id, active){
        return instance.put('/user/'+ id.toString(), {active, id})
    }   

    static async activateAccount(id, active){
        return instance.put('/account/'+ id.toString(), {'account': id, 'active':active})
    }   
    static async updateAccount(accountData){
        return instance.put('/account/' + accountData.account, accountData);

    }

    static async getPendingRegistrations() {
        return instance.get('/users', {
            params: {
                active: true,
                confirmed: false,
                roles: ''
            }
        });
    }

    static async activeUsers(ids){
        let registerData  = []
        ids.map(function (id){
            registerData.push({id: id, active: true, confirmed: true})
        });

        return instance.post('/users', {
            registerData
        })
    }

    static async processRegistrations(registrations){
        return await instance.put('/users', registrations)
    }

    static async createAccount(accountData){
        return instance.post('/account', accountData);
    }

    static async getMetrics(userId) {
        const url = '/customer/' + userId + '/product_metrics'
        return instance.get(url);
    }

    
}



// WEBPACK FOOTER //
// ./src/api/usersApi.js